import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { emitAllrvkmpyrgtm20 as emitAll } from '../Channels.mjs';
import { BufferOverflow_SUSPEND_getInstance1ucmryz5dsuc2 as BufferOverflow_SUSPEND_getInstance } from '../../channels/BufferOverflow.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { CoroutineStart_ATOMIC_getInstancehid42awkwncc as CoroutineStart_ATOMIC_getInstance } from '../../CoroutineStart.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { produce3s4oh9balbl5b as produce } from '../../channels/Produce.mjs';
import { coroutineScope2qhrb6lhutwsn as coroutineScope } from '../../CoroutineScope.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { EmptyCoroutineContext_instance3dshdbvg42f79 as EmptyCoroutineContext_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { get_classSimpleName2jgk6lzg9ft1 as get_classSimpleName } from '../../Debug.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { SendingCollector33jb503i6hglm as SendingCollector } from './SendingCollector.mjs';
import { newCoroutineContext1x74axajiiptk as newCoroutineContext } from '../../CoroutineContext.mjs';
import { Key_instance3cnd8e28exiq6 as Key_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/ContinuationInterceptor.mjs';
import { NopCollector2h4omm21qc7hq as NopCollector } from './NopCollector.mjs';
import { threadContextElements12yd4mfmaodla as threadContextElements } from '../../internal/ThreadContext.mjs';
import { startCoroutineUninterceptedOrReturnGeneratorVersion1cv0wx9z0l0zn as startCoroutineUninterceptedOrReturnGeneratorVersion } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../FlowCollector.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/Continuation.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ChannelFlow$_get_collectToFun_$slambda_j53z2e(this$0) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* this$0.collectTo_qjwlth_k$(it, $completion);
    return Unit_instance;
  }), 1);
}
function ChannelFlow$collect$slambda($collector, this$0) {
  return constructCallableReference(($this$coroutineScope, $completion) => orPromise($completion, function *($completion) {
    yield* emitAll($collector, this$0.produceImpl_qjsv5i_k$($this$coroutineScope), $completion);
    return Unit_instance;
  }), 1);
}
var ChannelFlowClass;
function ChannelFlow() {
  if (ChannelFlowClass === VOID) {
    class $ {
      constructor(context, capacity, onBufferOverflow) {
        this.context_1 = context;
        this.capacity_1 = capacity;
        this.onBufferOverflow_1 = onBufferOverflow;
        // Inline function 'kotlinx.coroutines.assert' call
      }
      get_collectToFun_6oxkuu_k$() {
        return ChannelFlow$_get_collectToFun_$slambda_j53z2e(this);
      }
      get_produceCapacity_futzxg_k$() {
        return this.capacity_1 === -3 ? -2 : this.capacity_1;
      }
      fuse_x525ca_k$(context, capacity, onBufferOverflow) {
        // Inline function 'kotlinx.coroutines.assert' call
        var newContext = context.plus_s13ygv_k$(this.context_1);
        var newCapacity;
        var newOverflow;
        if (!onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance())) {
          newCapacity = capacity;
          newOverflow = onBufferOverflow;
        } else {
          var tmp;
          if (this.capacity_1 === -3) {
            tmp = capacity;
          } else if (capacity === -3) {
            tmp = this.capacity_1;
          } else if (this.capacity_1 === -2) {
            tmp = capacity;
          } else if (capacity === -2) {
            tmp = this.capacity_1;
          } else {
            // Inline function 'kotlinx.coroutines.assert' call
            // Inline function 'kotlinx.coroutines.assert' call
            var sum = this.capacity_1 + capacity | 0;
            tmp = sum >= 0 ? sum : 2147483647;
          }
          newCapacity = tmp;
          newOverflow = this.onBufferOverflow_1;
        }
        if (equals(newContext, this.context_1) && newCapacity === this.capacity_1 && newOverflow.equals(this.onBufferOverflow_1))
          return this;
        return this.create_iagb5n_k$(newContext, newCapacity, newOverflow);
      }
      produceImpl_qjsv5i_k$(scope) {
        return produce(scope, this.context_1, this.get_produceCapacity_futzxg_k$(), this.onBufferOverflow_1, CoroutineStart_ATOMIC_getInstance(), VOID, this.get_collectToFun_6oxkuu_k$());
      }
      *collect_aksokr_k$(collector, $completion) {
        return yield* coroutineScope(ChannelFlow$collect$slambda(collector, this), $completion);
      }
      additionalToStringProps_j3cp6l_k$() {
        return null;
      }
      toString() {
        var props = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(4);
        var tmp0_safe_receiver = this.additionalToStringProps_j3cp6l_k$();
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          props.add_utx5q5_k$(tmp0_safe_receiver);
        }
        if (!(this.context_1 === EmptyCoroutineContext_instance)) {
          props.add_utx5q5_k$('context=' + toString(this.context_1));
        }
        if (!(this.capacity_1 === -3)) {
          props.add_utx5q5_k$('capacity=' + this.capacity_1);
        }
        if (!this.onBufferOverflow_1.equals(BufferOverflow_SUSPEND_getInstance())) {
          props.add_utx5q5_k$('onBufferOverflow=' + this.onBufferOverflow_1.toString());
        }
        return get_classSimpleName(this) + '[' + joinToString(props, ', ') + ']';
      }
    }
    protoOf($).fuse$default_g5zl2z_k$ = fuse$default;
    initMetadataForClass($, 'ChannelFlow', VOID, VOID, [FusibleFlow()], [1]);
    ChannelFlowClass = $;
  }
  return ChannelFlowClass;
}
function fuse$default(context, capacity, onBufferOverflow, $super) {
  context = context === VOID ? EmptyCoroutineContext_instance : context;
  capacity = capacity === VOID ? -3 : capacity;
  onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
  return $super === VOID ? this.fuse_x525ca_k$(context, capacity, onBufferOverflow) : $super.fuse_x525ca_k$.call(this, context, capacity, onBufferOverflow);
}
var FusibleFlowClass;
function FusibleFlow() {
  if (FusibleFlowClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'FusibleFlow', VOID, VOID, VOID, [1]);
    FusibleFlowClass = $;
  }
  return FusibleFlowClass;
}
var ChannelFlowOperatorImplClass;
function ChannelFlowOperatorImpl() {
  if (ChannelFlowOperatorImplClass === VOID) {
    class $ extends ChannelFlowOperator() {
      constructor(flow, context, capacity, onBufferOverflow) {
        context = context === VOID ? EmptyCoroutineContext_instance : context;
        capacity = capacity === VOID ? -3 : capacity;
        onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
        super(flow, context, capacity, onBufferOverflow);
      }
      create_iagb5n_k$(context, capacity, onBufferOverflow) {
        return new (ChannelFlowOperatorImpl())(this.flow_1, context, capacity, onBufferOverflow);
      }
      *flowCollect_ki1wtf_k$(collector, $completion) {
        return yield* this.flow_1.collect_aksokr_k$(collector, $completion);
      }
    }
    initMetadataForClass($, 'ChannelFlowOperatorImpl', VOID, VOID, VOID, [1]);
    ChannelFlowOperatorImplClass = $;
  }
  return ChannelFlowOperatorImplClass;
}
function *collectWithContextUndispatched($this, collector, newContext, $completion) {
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$0 = $completion.get_context_h02k06_k$();
  var originalContextCollector = withUndispatchedContextCollector(collector, tmp$ret$0);
  return yield* withContextUndispatched(newContext, originalContextCollector, VOID, ChannelFlowOperator$collectWithContextUndispatched$slambda($this), $completion);
}
function ChannelFlowOperator$collectWithContextUndispatched$slambda(this$0) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* this$0.flowCollect_ki1wtf_k$(it, $completion);
    return Unit_instance;
  }), 1);
}
var ChannelFlowOperatorClass;
function ChannelFlowOperator() {
  if (ChannelFlowOperatorClass === VOID) {
    class $ extends ChannelFlow() {
      constructor(flow, context, capacity, onBufferOverflow) {
        super(context, capacity, onBufferOverflow);
        this.flow_1 = flow;
      }
      *collectTo_qjwlth_k$(scope, $completion) {
        return yield* this.flowCollect_ki1wtf_k$(new (SendingCollector())(scope), $completion);
      }
      *collect_aksokr_k$(collector, $completion) {
        if (this.capacity_1 === -3) {
          // Inline function 'kotlin.js.getCoroutineContext' call
          var collectContext = $completion.get_context_h02k06_k$();
          var newContext = newCoroutineContext(collectContext, this.context_1);
          if (equals(newContext, collectContext))
            return yield* this.flowCollect_ki1wtf_k$(collector, $completion);
          if (equals(newContext.get_y2st91_k$(Key_instance), collectContext.get_y2st91_k$(Key_instance)))
            return yield* /*#__NOINLINE__*/collectWithContextUndispatched(this, collector, newContext, $completion);
        }
        yield* protoOf(ChannelFlow()).collect_aksokr_k$.call(this, collector, $completion);
        return Unit_instance;
      }
      toString() {
        return toString(this.flow_1) + ' -> ' + super.toString();
      }
    }
    initMetadataForClass($, 'ChannelFlowOperator', VOID, VOID, VOID, [1, 2]);
    ChannelFlowOperatorClass = $;
  }
  return ChannelFlowOperatorClass;
}
function withUndispatchedContextCollector(_this__u8e3s4, emitContext) {
  var tmp;
  var tmp_0;
  if (_this__u8e3s4 instanceof SendingCollector()) {
    tmp_0 = true;
  } else {
    tmp_0 = _this__u8e3s4 instanceof NopCollector();
  }
  if (tmp_0) {
    tmp = _this__u8e3s4;
  } else {
    tmp = new (UndispatchedContextCollector())(_this__u8e3s4, emitContext);
  }
  return tmp;
}
function *withContextUndispatched(newContext, value, countOrElement, block, $completion) {
  countOrElement = countOrElement === VOID ? threadContextElements(newContext) : countOrElement;
  // Inline function 'kotlinx.coroutines.withCoroutineContext' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var tmp0 = block;
    var tmp2 = value;
    // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
    var completion = new (StackFrameContinuation())(uCont, newContext);
    return startCoroutineUninterceptedOrReturnGeneratorVersion(tmp0, tmp2, completion);
  };
}
function UndispatchedContextCollector$emitRef$slambda($downstream) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* $downstream.emit_t92u1f_k$(it, $completion);
    return Unit_instance;
  }), 1);
}
var UndispatchedContextCollectorClass;
function UndispatchedContextCollector() {
  if (UndispatchedContextCollectorClass === VOID) {
    class $ {
      constructor(downstream, emitContext) {
        this.emitContext_1 = emitContext;
        this.countOrElement_1 = threadContextElements(this.emitContext_1);
        var tmp = this;
        tmp.emitRef_1 = UndispatchedContextCollector$emitRef$slambda(downstream);
      }
      *emit_t92u1f_k$(value, $completion) {
        return yield* /*#__NOINLINE__*/withContextUndispatched(this.emitContext_1, value, this.countOrElement_1, this.emitRef_1, $completion);
      }
    }
    initMetadataForClass($, 'UndispatchedContextCollector', VOID, VOID, [FlowCollector()], [1]);
    UndispatchedContextCollectorClass = $;
  }
  return UndispatchedContextCollectorClass;
}
var StackFrameContinuationClass;
function StackFrameContinuation() {
  if (StackFrameContinuationClass === VOID) {
    class $ {
      constructor(uCont, context) {
        this.uCont_1 = uCont;
        this.context_1 = context;
      }
      get_context_h02k06_k$() {
        return this.context_1;
      }
      resumeWith_rk9gbt_k$(result) {
        this.uCont_1.resumeWith_rk9gbt_k$(result);
      }
    }
    initMetadataForClass($, 'StackFrameContinuation', VOID, VOID, [Continuation()]);
    StackFrameContinuationClass = $;
  }
  return StackFrameContinuationClass;
}
//region block: exports
export {
  fuse$default as fuse$default2v3gehkaa3idr,
  ChannelFlowOperatorImpl as ChannelFlowOperatorImpl3gjkp847e0ebc,
  ChannelFlow as ChannelFlowvdfy82kdxy2m,
  FusibleFlow as FusibleFlow2tgh9s2p1kryd,
};
//endregion

//# sourceMappingURL=ChannelFlow.mjs.map
